import {
  IconMapMetroEkb16,
  IconMapMetroKzn16,
  IconMapMetroMsk16,
  IconMapMetroNN16,
  IconMapMetroNovosib16,
  IconMapMetroSam16,
  IconMapMetroSpb16,
} from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { TIcon } from 'shared/types/recommendedOffer';

export interface IIconsMetro {
  type: TIcon;
}

export const IconsMetro: React.FC<React.PropsWithChildren<IIconsMetro>> = ({ type }) => {
  switch (type) {
    case 'ekb':
      return <IconMapMetroEkb16 color="current_color" />;

    case 'kzn':
      return <IconMapMetroKzn16 color="current_color" />;

    case 'mow':
      return <IconMapMetroMsk16 color="current_color" />;

    case 'nn':
      return <IconMapMetroNN16 color="current_color" />;

    case 'nsk':
      return <IconMapMetroNovosib16 color="current_color" />;

    case 'smr':
      return <IconMapMetroSam16 color="current_color" />;

    case 'spb':
      return <IconMapMetroSpb16 color="current_color" />;

    default:
      return null;
  }
};

IconsMetro.displayName = 'IconsMetro';
